import { Link as RouterLink } from 'react-router'

import IdcardOutlinedIcon from '@ant-design/icons/IdcardOutlined'
import BusinessIcon from '@icons/BusinessIcon'
import LocationIcon from '@icons/LocationIcon'
import MedicalServiceIcon from '@icons/MedicalServiceIcon'

import Divider from '@mui/material/Divider'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Link from '@components/_mui/Link'
import Typography from '@components/_mui/Typography'

import { RoleGuard } from '@shared/providers/src/MeProvider'
import { UserRole } from '@shared/utils'

export default function Content({ cbo }) {
  const { primaryPharmacy, secondaryPharmacy } = cbo

  const address = [cbo.city, cbo.state].filter(Boolean).join(', ')
  const vendors = (cbo.labVendors || []).map((v) => v.name).join(', ')
  const services = (cbo.cbosProviderTypes || cbo.providerTypes || []).map((v) => v.name).join(', ')

  return (
    <>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
        <Stack direction="row" spacing={1}>
          <IdcardOutlinedIcon style={{ fontSize: 16 }} />
          <RoleGuard allowed={[UserRole.Admin]}>
            <Link component={RouterLink} to={`/app/cbos/${cbo.id}`} fontWeight="bold" target="_blank">
              {cbo.id}
            </Link>
          </RoleGuard>
          <RoleGuard prohibited={[UserRole.Admin]}>
            <Typography>{cbo.id}</Typography>
          </RoleGuard>
        </Stack>
        <Link component={RouterLink} to={`/app/cbos/${cbo.id}/rule-set`} fontWeight="bold" target="_blank">
          Rule-set
        </Link>
      </Stack>
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <LocationIcon style={{ fontSize: 16 }} />
          <Typography>{address || '-'}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <BusinessIcon style={{ fontSize: 16 }} />
          <Typography>{vendors || '-'}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <MedicalServiceIcon style={{ fontSize: 16 }} />
          <Typography>{services || '-'}</Typography>
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Accepting New Patients</Typography>
          <Typography>{cbo.acceptingNewPatients ? 'Yes' : 'No'}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Allow Uninsured</Typography>
          <Typography>{cbo.cboPreventUninsured ? 'No' : 'Yes'}</Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Maintains Uninsured Patients</Typography>
          <Typography>{cbo.maintainsUninsuredPatients ? 'Yes' : 'No'}</Typography>
        </Stack>
      </Stack>
      {(primaryPharmacy || secondaryPharmacy) && (
        <>
          <Divider />
          <Stack spacing={1}>
            <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 'bold' }}>
              Pharmacy
            </Typography>
            <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
              <Typography>Primary</Typography>
              <Typography>{primaryPharmacy?.name || '-'}</Typography>
            </Stack>
            <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
              <Typography>Secondary</Typography>
              <Typography>{secondaryPharmacy?.name || '-'}</Typography>
            </Stack>
          </Stack>
        </>
      )}
    </>
  )
}

Content.Loading = function () {
  return (
    <>
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <IdcardOutlinedIcon style={{ fontSize: 16 }} />
          <Typography>
            <Skeleton width={80} />
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <LocationIcon style={{ fontSize: 16 }} />
          <Typography>
            <Skeleton width={150} />
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <BusinessIcon style={{ fontSize: 16 }} />
          <Typography>
            <Skeleton width={180} />
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <MedicalServiceIcon style={{ fontSize: 16 }} />
          <Typography>
            <Skeleton width={200} />
          </Typography>
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={1}>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Accepting New Patients</Typography>
          <Typography>
            <Skeleton width={80} />
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Allow Uninsured</Typography>
          <Typography>
            <Skeleton width={80} />
          </Typography>
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={1}>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 'bold' }}>
          Pharmacy
        </Typography>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Primary</Typography>
          <Typography>
            <Skeleton width={100} />
          </Typography>
        </Stack>
        <Stack direction="row" spacing={1} sx={{ justifyContent: 'space-between' }}>
          <Typography>Secondary</Typography>
          <Typography>
            <Skeleton width={100} />
          </Typography>
        </Stack>
      </Stack>
    </>
  )
}
